import { render, staticRenderFns } from "./AubeStakeTerms.vue?vue&type=template&id=515bee64&scoped=true&"
import script from "./AubeStakeTerms.vue?vue&type=script&lang=js&"
export * from "./AubeStakeTerms.vue?vue&type=script&lang=js&"
import style0 from "./AubeStakeTerms.vue?vue&type=style&index=0&id=515bee64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515bee64",
  null
  
)

export default component.exports